@if (hasValidAccount) {
  <div id="ip-common">
    <header>
      @if (!isProduction) {
        <lib-environment-banner></lib-environment-banner>
      }
      <lib-alert-info></lib-alert-info>
      <lib-notification-info></lib-notification-info>
      <lib-skip-to-content mainId="main-content"></lib-skip-to-content>
      <lib-site-header
        [site]="EtjansterSites.Ansok"
        [sitesToShow]="[
          EtjansterSites.Start,
          EtjansterSites.Ansok,
          EtjansterSites.Projekt,
          EtjansterSites.Bedom,
          EtjansterSites.MinProfil,
        ]"
        [authenticated]="hasValidAccount"
      ></lib-site-header>
      <lib-english-disclaimer></lib-english-disclaimer>
    </header>
    <main class="ip-body" id="main-content">
      <lib-toast-container></lib-toast-container>
      <div class="container-lg position-relative flex-fill">
        @if (!hasError) {
          <router-outlet></router-outlet>
        }
      </div>
    </main>
    @if (showChatbot) {
      <vinnova-chatbot-widget> </vinnova-chatbot-widget>
    }
    <lib-site-footer></lib-site-footer>
  </div>
}
<lib-already-logged-in></lib-already-logged-in>

<lib-cookie-banner></lib-cookie-banner>
